import _ from 'underscore';
import { pluginName } from './strophe.main';

let Strophe = window.Strophe;
let connection;
let connPlugin;
let connCfg;
let connectStatus = {};
let reConnectTimes = 0;
let reConnectTimer;
let readyList = [];
let offlineTimer;

function setupConnection({ im_server, resource }) {
    if (connection) return;

    connection = new Strophe.Connection(im_server);
    connPlugin = connection[pluginName];
    connPlugin.setDefaultNick(resource);
}

function handlerMessage(message, msgCb, actionCb) {
    let type = message.type || '';
    let body = message.body || {};
    let bodyType = body.type || '';

    message.body = body;

    if (bodyType.indexOf('Action:') === 0) {
        return actionCb && actionCb(bodyType.split(':')[1], message);
    }

    if (!_.isEmpty(body)) {
        if (_.contains(['chat', 'groupchat'], type)) {
            type = type === 'chat' ? 'user' : 'group';
            return msgCb && msgCb(type, message);
        }
    }
}

function handlerPresence(presence, cb) {
    let { from, type, body = {} } = presence;
    let { status } = body;
    let resource = from.split('/')[1];

    if (status === 'online') {
        type = 'available';
    }

    if (resource) {
        presence.user_id = parseInt(resource.split('_')[0]);
    }

    switch (type) {
        case 'available':
            type = 'online';
            break;
        case 'unavailable':
            type = 'offline';
            offlineTimer = setTimeout(() => {
                cb && cb(type, presence);
            }, 3000);
            break;
        default:
            break;
    }

    if (type && type !== 'offline') {
        clearTimeout(offlineTimer);
        cb && cb(type, presence);
    }
}

/**
    cfg: {
        jid,
        password,
        im_server,
        onMessage
        onPresence,
        onConnectStatus
    }
*/
function connect(cfg) {
    connCfg = cfg;

    if (connectStatus.connected) return;

    setupConnection(connCfg);
    connPlugin.connect(connCfg, {
        connected() {
            reConnectTimes = 0;
            clearTimeout(reConnectTimer);
            connPlugin.onMessage((message) => { handlerMessage(message, cfg.onMessage, cfg.onAction) }); //消息监听
            connPlugin.onPresence((presence) => { handlerPresence(presence, cfg.onPresence) }); //客服状态监听
            //执行readyList
            if (readyList.length) {
                _.each(readyList, (fn) => fn());
                readyList.length = 0;
            }
        },
        always(status) {
            var oldStatus = connectStatus.value;
            connectStatus = {};
            connectStatus[status] = true;
            connectStatus.value = status;
            cfg.onConnectStatus && cfg.onConnectStatus(status, oldStatus);

            switch (status) {
                case "disconnected":
                case "connfail":
                case "authfail":
                    clearTimeout(reConnectTimer);
                    reConnectTimer = setTimeout(reConnect, reConnectTimes < 3 ? 5000 : 10000);
                    reConnectTimes++;
                    break;
                default:
                    break;
            }
        }
    });
}

function reConnect() {
    connect(connCfg);
}

function ready(handler) {
    if (connectStatus.connected) {
        handler();
    } else {
        readyList.push(handler);
    }
}

export default {
    ready,
    connect,
    joinGroup({ jid }) {
        connPlugin.joinRoom({ to: jid });
    },
    subscribeGroup({ jid }) {
        connPlugin.subscribeRoom({ to: jid });
    },
    setupGroups(groups) {
        _.each(groups, (item) => {
            this.joinGroup(item);
            this.subscribeGroup(item);
        });
    }
}


// WEBPACK FOOTER //
// ./src/utils/webIM/index.js